import React from 'react';
import FormErrors from "./form_errors";
import {_t} from "../../../js/app/common/utils/locale";

export default class FormLogin extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || ''
        };
    }

    onChange(event) {
        const filteredInput = event.target.value.replace(/[^a-zA-Z0-9]/g, '');

        this.setState({
            value: filteredInput
        });

        this.props.onChange(filteredInput);
    }

    render() {
        return (
            <div className="cluster__form-group">
                <div className="form-group">
                    <label className={'label ' + (this.props.labelClass)} htmlFor={this.props.name}>{_t(this.props.label)}</label>
                    <input
                        type="text"
                        className={'form-control input ' + (this.props.errors ? 'is-invalid' : '')}
                        id={this.props.name}
                        name={this.props.name}
                        disabled={this.props.disabled}
                        placeholder={_t((this.props.placeholder ? this.props.placeholder : this.props.label))}
                        required={this.props.required ? 'required' : ''}
                        onChange={this.onChange.bind(this)}
                        value={this.state.value}
                        onBlur={this.props.onBlur}
                    />
                    <FormErrors errors={this.props.errors} />
                </div>
            </div>
        );
    }

}